import {useState, useRef, useEffect} from 'react'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask'
import { AddressSuggestions, PartyRussiaSuggestions } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';
import {useDispatch, useSelector} from "react-redux";
import {setInnSelected} from "../../redux/modules/auth";

const limits = {
  email: {
    min: 5,
    regex: /^[a-zA-Z0-9-_.]+@[a-zA-Z0-9-]+\.[A-Za-z]+$/
  },
  name: {
    regex: /^[а-яА-Я-]+$/
  },
  text: {
    min: 1
  },  
  address: {
    min: 1
  },
  phone: {
    min: 16,
    regex: /^(\+7)?[\s\-]?\(?[0-9]{3}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/
  },
  code: {
    min: 4,
    regex: /^[0-9]+$/
  },
  number: {
    regex: /^[0-9]+$/
  },
  inn_ur: {
    //checkinn: false,
    min: 10
  },
  inn_fiz: {
    //checkinn: false,
    min: 12
  },
}

const InputField = ({value, name, type, label, placeholder, valid, validate, example, checkresult, disable, status, setFieldValid, setValue, setAddress, setInn, setValueSelect, keyUp, change, trigger}) => {
  const inputRef = useRef(null)
  const suggestionsRef = useRef(null)
  const [focused, setFocused] = useState(false)
  const [active, setActive] = useState(false)
  const dispatch = useDispatch()
  const isSelected = useSelector(state => state.auth.isInnSelected)
  const legaltype = useSelector(state => state.auth.legaltype)

  const isValidField = () => {
    const limit = limits[validate]

    if (!limit) return true

    if (limit.regex && !limit.regex.test(value)) {
      return false
    }

    if ((limit.min && !value) || (limit.min && value.length < limit.min)) {
      return false
    }

    return true
  }

  const handleKeyUp = (keyUp) => {
    if(keyUp) keyUp()
    const valid = isValidField()
    setFieldValid(name, valid, valid)
  }

  const handleBlur = (ev) => {
    const valid = isValidField()
    setFieldValid(name, valid, valid)
    setFocused(false);
  }

  const handleFocus = (ev) => {
    setFieldValid(name, true, name !== 'code' && name !== 'city' ? isValidField() : true)
  }

  const handleSetValue = (ev, sug) => {    
    console.log(ev.target.value)
    if(sug) dispatch(setInnSelected(false));
    sug ? setInn(ev.target, true) : setAddress(ev.target, true)
  }

  const labelClick = (ev) => {
    inputRef.current.focus();
    setFocused(true);
  }

  const setInputRef = (element) => {
    if(!inputRef.current){
      inputRef.current = element;
    }
  }
  const setSuggestionRef = (data) => {
    setInn(data)
    setActive(true)
    dispatch(setInnSelected(true))
    if (suggestionsRef.current) {
      suggestionsRef.current.setInputValue(data.data.inn);
    }
  }

  useEffect(() => {
    return () => dispatch(setInnSelected(false));
  }, []);

  useEffect(() => {
    if(suggestionsRef.current) {
      setInn({value:''}, true)
      //setValue({target: { name: 'inn', value:''}})
      suggestionsRef.current.setInputValue('');
      //if(setAddress) setAddress({value:''}, true)
    }
  }, [legaltype]);

  return (
    <div
      className={name === 'city' ? "form__group form__group_search" : "form__group"}
      data-valid={valid || (!value && !trigger) ? 'true' : 'false'}
      data-error={!valid && trigger ?'true' : 'false'}
      data-active={name === 'inn' ? true : isSelected}
      data-disable={disable}
      data-status={status}
    >
      {label && <div className={(value || focused) ? "form__label form__label_fixed" : "form__label"} onClick={labelClick}>{label}</div>}
      {validate === 'phone' ? (
        <InputMask
          inputRef={(el) => setInputRef(el)}
          mask='+7 999 999 99 99'
          maskChar={null}
          name={name}
          value={value}
          type={type}
          placeholder={placeholder}
          replacement={{ _: /\d/ }}
          className={valid || (!value && !trigger) ? 'form__input' : 'form__input form__input_error'}
          onBlur={handleBlur}
          onFocus={handleFocus}
          //onChange={setValue}
          onChange={(e) => {if(change) {change();}setValue(e)}}
          onKeyUp={() => handleKeyUp(keyUp ? keyUp : '')}
          autoComplete="off"
        />
      ) : validate === 'address' ? (
        <AddressSuggestions 
          token="ee362705dd7622404905773a2c3a912fff00a151"
          name={name}
          type={type}

          //placeholder={placeholder}
          replacement={{ _: /\d/ }}
          containerClassName={valid || (!value && !trigger) ? '' : 'error'}
          //onBlur={handleBlur}
          //onFocus={handleFocus}
          onChange={setAddress}
          //onKeyUp={handleKeyUp}
          filterFromBound="city"
          filterToBound="city"
          autoComplete="off"

          inputProps={{
            'placeholder': placeholder,
            'onChange': (event) => {
              handleSetValue(event)
            },
          }}
        />
      ) : validate === 'code' ? (
        <InputMask
          mask={'9999'}
          maskChar={null}
          name={name}
          value={value}
          type={type}
          placeholder={placeholder}
          replacement={{ _: /\d/ }}
          className={valid || (!value && !trigger) ? 'form__input' : 'form__input form__input_error'}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onChange={setValue}
          onKeyUp={keyUp}
          inputmode="numeric"
          pattern="[0-9]"
          textContentType="oneTimeCode"
          autoComplete="one-time-code"
        />
      ) : (validate === 'inn_ur' || validate === 'inn_fiz') ? (

        <PartyRussiaSuggestions
          ref={suggestionsRef}
          token="ee362705dd7622404905773a2c3a912fff00a151"
          onChange={setSuggestionRef}
          name={name}
          type={type}
          //value={value}
          replacement={{ _: /\d/ }}
          containerClassName={valid || (!value && !trigger) ? '' : 'error'}
          autoComplete="off"
          inputProps={{
            'placeholder': placeholder,
            'onInput': (event) => {
              event.target.value = event.target.value.replace(/\D/g, '') 
            },
            'onChange': (event) => {
              const onlyNumbers = event.target.value.replace(/\D/g, '') 
              handleSetValue({ target: { value: onlyNumbers } }, true)
            },
            'maxLength': validate === 'inn_ur' ? 10 : 12
          }}
        />
      ) : validate === 'number' ? ( 
        <input
          ref={inputRef}
          name={name}
          value={value}
          type={type}
          placeholder={placeholder}
          className={valid || (!value && !trigger) ? 'form__input' : 'form__input form__input_error'}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onChange={setValue}
          onInput={(event) => {
            event.target.value = event.target.value.replace(/\D/g, '') 
          }}
          onKeyUp={() => handleKeyUp(keyUp ? keyUp : '')}
          autoComplete="off"
        />
      ) : (
        <input
          ref={inputRef}
          name={name}
          value={value}
          type={type}
          placeholder={placeholder}
          className={valid || (!value && !trigger) ? 'form__input' : 'form__input form__input_error'}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onChange={setValue}
          onKeyUp={() => handleKeyUp(keyUp ? keyUp : '')}
          autoComplete="off"
        />
      )}
      {example && <div className="form__byline">{example}</div>}
      {checkresult && <div className="form__byline form__byline_static">{checkresult}</div>}
    </div>
  )

}

InputField.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
  validate: PropTypes.string,
  setFieldValid: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  trigger: PropTypes.bool.isRequired,
}


export default InputField
